import { useGetTruckImplementsQuery } from "@/store";

export function useTruckImplements() {
  const state = useGetTruckImplementsQuery();

  // Criamos a função utilitária aqui, fora do estado do Redux
  const findImplementByType = (type: string) => {
    return state.data?.find((implement) => implement?.name === type);
  };

  const findImplementById = (id: number) => {
    return state.data?.find((implement) => implement?.id === id);
  };

  return {
    findImplementByType,
    findImplementById,
    ...state
  };
}
